<template>
	<div class="c-user-contanier">
		<div class="header">
			<BackTitle title="个人中心" />
			<div class="header-right">
				<AccountCoin />
				<Logout :user="user" />
			</div>
		</div>

		<div class="main">
			<!-- 侧边栏 -->
			<LMenu class="user-menu" v-model="menuActive" />
			<div class="user-content">
				<userinfo v-show="menuActive == 0" @userInfo="getUserInfo"></userinfo>
				<!-- 我的记录 -->
				<UserRecord v-show="menuActive == 1" />
				<!-- 消息通知 -->
				<notice v-show="menuActive == 2" ref="noticeComponents" @noticeRedDot="noticeRedDot"></notice>
				<!-- 赛季战况 -->
				<remake v-if="menuActive == 3"></remake>
			</div>

		</div>
	</div>
</template>

<script>
import userinfo from "./components/userinfo"
import UserRecord from "./components/record"
import notice from "./components/notice.vue"
import Logout from "./components/logout.vue"
import LMenu from "@/components/l-menu/l-menu"
import remake from "./components/remake.vue"
import BackTitle from "./components/back-title/BackTitle.vue"
import AccountCoin from "./components/account-coin/AccountCoin.vue"

export default {
	name: "Center",
	components: {
		userinfo,
		UserRecord,
		notice,
		Logout,
		LMenu,
		remake,
		BackTitle,
		AccountCoin,
	},
	data() {
		return {
			user: "",
			menuActive: 0,
			unRead: false,
		}
	},
	methods: {
		noticeRedDot(info) {
			this.unRead = info
		},
		getUserInfo(info) {
			this.user = info
		},

		//处理跳转获取到的参数
		handleUserUrlType() {
			if (this.$route.query.type) {
				this.menuActive = this.$route.query.type - 1
			}
		},
	},
	mounted() {
		//直接触发notice子组件方法，来展示“消息通知”菜单是否存在红点
		this.$refs.noticeComponents.getMessage(1)
		this.getUserInfo()
		this.handleUserUrlType()
	},
}
</script>

<style scoped>
.c-user-contanier {
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	height: 100%;
	padding-top: 24px;
	background: url("./images/bg.png") center/cover no-repeat;
	overflow: hidden;
}
.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.header-right {
	display: flex;
	align-items: center;
	gap: 28px;
	padding-right: 28px;
}

.main {
	display: flex;
	flex: 1;
	margin-top: 80px;
	overflow: hidden;
}
.user-menu {
	margin-left: 76px;
}
.user-content {
	flex: 1;
	margin-left: 100px;
	margin-right: 72px;
	overflow: hidden;
}
</style>
